export default __webpack_public_path__ + "static/media/GM Fabrics Private Limited.bc156547.jpg";